import React, { useEffect, useRef } from 'react';

const TextBox = ({ value, readOnly, onChange ,name}) => {
  const textAreaRef = useRef(null);

  useEffect(() => {
    const adjustHeight = () => {
      if (textAreaRef.current) {
        // Reset height to auto to get the scroll height
        textAreaRef.current.style.height = 'auto';
        // Set height to scroll height
        textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      }
    };

    adjustHeight(); // Adjust height on mount and when value changes
    window.addEventListener('resize', adjustHeight); // Adjust height on window resize
    return () => window.removeEventListener('resize', adjustHeight); // Cleanup event listener
  }, [value]);

  return (
    <textarea 
      ref={textAreaRef} 
      style={{ width: '100%', resize: 'none' }} 
      value={value} 
      name={name} 
      readOnly={readOnly} 
      onChange={onChange} 
    />
  );
};

export default TextBox;